class SizeGuide extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  async setupListeners () {
    super.setupListeners()

    const templateLoaded = await this.renderTemplate()

    if (templateLoaded) {
      this.els.mainTabTrigger.elements.forEach((tab) => {
        tab.addEventListener('click', (evt) => {
          const tabId = tab.getAttribute('data-tab')
          if (tabId) {
            this.openTabs(evt, tabId)
          }
        })
      })

      this.els.unitTabTrigger.elements.forEach((unitBtn) => {
        unitBtn.addEventListener('click', (evt) => {
          const unitBtnId = unitBtn.getAttribute('data-unit-tab')
          if (unitBtnId) {
            this.openUnits(evt, unitBtnId)
          }
        })
      })
    }
  }

  openTabs (evt, tabId) {
    const tabButtons = this.els.mainTabTrigger.elements
    const tabContents = this.els.mainTabContent.elements

    let targetContent
    if (this.els.mainTabTrigger.element.hasAttribute('data-tab-content')) {
      const attr =
        this.els.mainTabTrigger.element.getAttribute('data-tab-content')
      targetContent = document.querySelector(
        `.tab-content[data-tab-content="${attr}"]`,
      )
    } else {
      targetContent = document.querySelector(
        `.tab-content[data-tab-content="${tabId}"]`,
      )
    }

    tabButtons.forEach((button) => {
      button.classList.remove('active')
    })
    tabContents.forEach((content) => {
      content.classList.remove('active')
    })

    if (targetContent) {
      targetContent.classList.add('active')
    }

    evt.currentTarget.classList.add('active')
  }

  openUnits (evt, unitBtnId) {
    const unitButtons = this.els.unitTabTrigger.elements
    const unitContents = this.els.unitTabContent.elements

    unitButtons.forEach((button) => {
      button.classList.remove('active')
    })
    unitContents.forEach((content) => {
      content.classList.remove('active')
    })

    const targetContent = document.querySelector(
      `[data-unit-content="${unitBtnId}"]`,
    )
    if (targetContent) {
      targetContent.classList.add('active')
    }

    evt.currentTarget.classList.add('active')
  }

  async renderTemplate () {
    const handle = this.dataset.handle

    if (!handle) return false

    let pageContent = ''
    try {
      const pageResponse = await fetch(
        `/pages/${handle}?view=venn_header_footer`,
      )

      if (!pageResponse.ok) throw new Error('Page not found')
      const html = await pageResponse.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')
      const content = doc.querySelector('.content-container')

      pageContent = content ? content.innerHTML : ''
    } catch (e) {
      pageContent = '<p>Could not load size guide content.</p>'

      this.els.body.element.innerHTML = pageContent

      return false
    }

    this.els.body.element.innerHTML = pageContent
    return true
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
